import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import ContractsEvents from './ContractsEvents';

import ContractsDetailsSectionInfo from './details/sections/ContractsDetailsSectionInfo';
import ContractsDetailsSectionSecondaryInfo from './details/sections/ContractsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<ContractsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<ContractsDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="cntr_descriptionhtml"
				value={props.model.cntr_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_FLOW_SECTION" />
			<DetailsSectionFlowContent module="contracts" {...props} />
		</>
	),
	events: ContractsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
